const REPORT_EDITABLE_FIELDS = [
  [
    { id: "facility_type", type: "text" },
    { id: "facility_name", type: "text" },
    { id: "part_name", type: "text" },
  ],
  [
    { id: "building_name", type: "text" },
    { id: "floor", type: "text" },
    { id: "location", type: "text" },
  ],
  [
    { id: "shooting_date", type: "text" },
    { id: "ambient_temp", type: "text" },
    { id: "equipment_used", type: "text" },
  ],
  [{ id: "serial_number", type: "text" }],
];

export default function Ud1000VideoEditModal({
  t,
  form,
  handleChange,
  handleFusionResultChange,
  toFusionCode,
  fusionLabels,
  setIsReadOnly,
  onSave,
  isSaving,
  hasChanges,
}) {
  return (
    <div
      className="reportEditModalOverlay"
      role="presentation"
      onClick={() => setIsReadOnly(false)}
    >
      <div
        className="reportEditModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ud-video-report-edit-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="reportEditModalHeader">
          <div className="titleBox">
            <h3 id="ud-video-report-edit-title">{t("editorBtnBox.editButton")}</h3>
            <p>{t("videoFileIndex.report.title")}</p>
          </div>

          <button
            type="button"
            className="iconBtn"
            onClick={() => setIsReadOnly(false)}
            aria-label={t("editorBtnBox.cancelButton")}
          >
            X
          </button>
        </div>

        <div className="reportEditModalBody">
          {REPORT_EDITABLE_FIELDS.map((row, rowIndex) => (
            <div className="reportEditGrid" key={`video-report-edit-row-${rowIndex}`}>
              {row.map((field) => (
                <label className="reportEditField" key={field.id}>
                  <span className="label">{getFieldLabel(field.id, t)}</span>
                  <input
                    id={field.id}
                    type={field.type}
                    value={form?.[field.id] ?? ""}
                    onChange={handleChange}
                  />
                </label>
              ))}
            </div>
          ))}

          <div className="reportEditGrid">
            <label className="reportEditField">
              <span className="label">
                {t("videoFileIndex.report.fusionResultMultiline")}
              </span>
              <select
                onChange={handleFusionResultChange}
                id="fusion_result"
                value={toFusionCode(form?.fusion_result_code ?? form?.fusion_result) ?? 0}
              >
                <option value={0}>{fusionLabels[0]}</option>
                <option value={1}>{fusionLabels[1]}</option>
                <option value={2}>{fusionLabels[2]}</option>
                <option value={3}>{fusionLabels[3]}</option>
              </select>
            </label>
          </div>

          <label className="reportEditField textareaField">
            <span className="label">
              {t("videoFileIndex.report.inspectionResult.title")}
            </span>
            <textarea
              className="inspection"
              onChange={handleChange}
              id="inspection_result"
              value={form?.inspection_result ?? ""}
            />
          </label>
        </div>

        <div className="reportEditModalFooter">
          <button
            type="button"
            className="ghostBtn"
            onClick={() => setIsReadOnly(false)}
            disabled={isSaving}
          >
            {t("editorBtnBox.cancelButton")}
          </button>
          <button
            type="button"
            className="primaryBtn"
            onClick={onSave}
            disabled={!hasChanges || isSaving}
          >
            {isSaving ? "Saving..." : t("editorBtnBox.saveButton")}
          </button>
        </div>
      </div>
    </div>
  );
}

function getFieldLabel(id, t) {
  const labelMap = {
    facility_type: t("videoFileIndex.report.facilityType"),
    facility_name: t("videoFileIndex.report.facilityName"),
    part_name: t("videoFileIndex.report.partName"),
    building_name: t("videoFileIndex.report.buildingName"),
    floor: t("videoFileIndex.report.floor"),
    location: t("videoFileIndex.report.location"),
    shooting_date: t("videoFileIndex.report.shootingDate"),
    ambient_temp: t("videoFileIndex.report.ambientTemperature"),
    equipment_used: t("videoFileIndex.report.equipmentUsed"),
    serial_number: t("videoFileIndex.report.serialNumber"),
  };

  return labelMap[id] ?? id;
}
